import Logo from "../assets/images/robanzo.png";
import LogoTwo from "../assets/images/192.png";

const config = {
  url: "https://app.robanzo.co/",
  urlApi: "https://robanzo.co/api/",
  ipServer: "http://test/",
  perfix: "robanzo_",
  timeout: 6000,
  language: "fa",
  title: "رُبانزو",
  currency: "تومان",
  description: "رستوران ایتالیایی - رُبانزو",
  logo: Logo,
  logoTwo: LogoTwo,
  toastAutoClose: 3000,
  page: 1,
  pageSize: 10,
  version: "2.7.8",
};

export default config;
